const initialSlideListState = {
  fetching: false,
  fetched: false,
  items: [],
  statusCounts: { CREATED: 0, STANDARD: 0, ALL: 0 },
  error: null,
  nbResult: 0,
  pageSize: 12,
  suggestions: {
    fetching: false,
    fetched: false,
    items: []
  },
  paginationPage: 1,
  filterStatus: "",
  selected: [],
  filter: {
    labels: "",
    indicators: [],
    status: []
  },
  saving: false,
  saved: false
};
export const slideListReducer = (state = initialSlideListState, action) => {
  switch (action.type) {
    case "INIT_SLIDES_LIST_FILTER": {
      return initialSlideListState;
    }
    case "SET_SLIDES_LIST_PAGINATION_PAGE": {
      return { ...state, paginationPage: action.pageNumber };
    }
    case "SET_SLIDES_LIST": {
      return { ...state, items: action.slide };
    }
    case "FETCH_SLIDES_LIST_PENDING": {
      return { ...state, fetched: false, fetching: true };
    }
    case "FETCH_SLIDES_LIST_FULFILLED": {
      const { data, nbResult, statusCounts } = action.payload.data;
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        items: data || [],
        selected: [],
        statusCounts: statusCounts,
        nbResult: nbResult
      };
    }
    case "SET_SLIDES_SELECTED_ITEM": {
      return {
        ...state,
        selected: action.selected
      };
    }
    case "SET_SLIDES_LIST_PAGE_SIZE": {
      return {
        ...state,
        pageSize: action.pageSize,
        paginationPage: 1
      };
    }
    case "SET_SLIDES_LIST_FILTER_TITLE": {
      return {
        ...state,
        filter: { ...state.filter, labels: action.title },
        paginationPage: 1
      };
    }
    case "DELETE_SLIDE_PENDING": {
      return { ...state, saved: false, saving: true };
    }
    case "DELETE_SLIDE_FULFILLED": {
      let { params } = action.payload.config;
      let slides = [...state.items].filter(slide => {
        return params.id !== slide.id;
      });
      return { ...state, saved: true, saving: false, items: slides };
    }
    case "DELETE_SLIDE_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 500:
          error = {
            title: error.response.data.title,
            code: 500
          };
          break;
        default:
      }
      return {
        ...state,
        saved: false,
        error
      };
    }
    case "DUPLICATE_SLIDE_PENDING": {
      return { ...state, saved: false, saving: true };
    }
    case "DUPLICATE_SLIDE_FULFILLED": {
      return { ...state, saved: true, saving: false };
    }
    case "DUPLICATE_SLIDE_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 500:
          error = {
            title: error.response.data.title,
            code: 500
          };
          break;
        default:
      }
      return {
        ...state,
        saved: false,
        error
      };
    }
    case "UPDATE_PRIVACY_SLIDE_PENDING": {
      return { ...state, saved: false, saving: true };
    }
    case "UPDATE_PRIVACY_SLIDE_FULFILLED": {
      return { ...state, saved: true, saving: false };
    }
    case "UPDATE_PRIVACY_SLIDE_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 500:
          error = {
            title: error.response.data.title,
            code: 500
          };
          break;
        default:
      }
      return {
        ...state,
        saved: false,
        error
      };
    }
    case "UPDATE_STATE_SLIDE_PENDING": {
      return { ...state, saved: false, saving: true };
    }
    case "UPDATE_STATE_SLIDE_FULFILLED": {
      return { ...state, saved: true, saving: false };
    }
    case "UPDATE_STATE_SLIDE_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 500:
          error = {
            title: error.response.data.title,
            code: 500
          };
          break;
        default:
      }
      return {
        ...state,
        saved: false,
        error
      };
    }
    case "SET_SLIDE_PRIVATE_PENDING": {
      return { ...state, saved: false, saving: true };
    }
    case "SET_SLIDE_PRIVATE_FULFILLED": {
      return { ...state, saved: true, saving: false };
    }
    case "SET_SLIDE_PRIVATE_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 500:
          error = {
            title: error.response.data.title,
            code: 500
          };
          break;
        default:
      }
      return {
        ...state,
        saved: false,
        error
      };
    }
    case "USE_SHARED_SLIDE_PENDING": {
      return { ...state, saved: false, saving: true };
    }
    case "USE_SHARED_SLIDE_FULFILLED": {
      return { ...state, saved: true, saving: false };
    }
    case "USE_SHARED_SLIDE_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 500:
          error = {
            title: error.response.data.title,
            code: 500
          };
          break;
        default:
      }
      return {
        ...state,
        saved: false,
        error
      };
    }
    case "SET_SLIDES_FILTER_INDICATORS": {
      return {
        ...state,
        filter: { ...state.filter, indicators: action.indicators },
        paginationPage: 1
      };
    }
    case "SET_SLIDES_LIST_FILTER_STATUS": {
      return {
        ...state,
        filter: { ...state.filter, status: action.status },
        paginationPage: 1
      };
    }
    case "SET_SLIDES_LIST_FILTER_IS_PUBLIC": {
      return {
        ...state,
        filter: {
          ...state.filter,
          isPublic: action.isPublic,
          operator: action.operator
        },
        paginationPage: 1
      };
    }
    case "SET_SLIDES_LIST_FILTER_NEW_SLIDE_IDS": {
      return {
        ...state,
        filter: {
          ...state.filter,
          newSlideIds: action.newSlideIds
        },
        paginationPage: 1
      };
    }

    case "SET_SLIDES_FILTER": {
      return {
        ...state,
        filterStatus: action.filterStatus,
        paginationPage: 1
      };
    }
    case "FETCH_INDICATOR_SUGGESTIONS_PENDING": {
      return { ...state, suggestions: { fetched: false, fetching: true } };
    }
    case "FETCH_INDICATOR_SUGGESTIONS_FULFILLED": {
      const { data } = action.payload;
      return {
        ...state,
        suggestions: {
          fetched: true,
          fetching: false,
          items: data || []
        },
        error: null
      };
    }
    case "FETCH_INDICATOR_SUGGESTIONS_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
      }
      return {
        ...state,
        suggestions: {
          fetching: false,
          items: []
        },
        error
      };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/slideList.js